import { timeRangeDurationMinutes } from '@zag/calendar/models';
import type { ShiftOverrideApprovalInfo } from '../models/shift-override-approval.model';

type ShiftOverrideApprovalStatus = ShiftOverrideApprovalInfo['status'];

export const LIVE_SHIFT_OVERRIDE_STATUSES: readonly ShiftOverrideApprovalStatus[] = ['pending', 'approved', 'rejected'];

export interface ShiftOverrideApprovalRow {
  id: string;
  payload: Record<string, unknown>;
  decisionComment: string | null;
  decidedAt: Date | null;
  firstName: string | null;
  lastName: string | null;
}

export function liveShiftOverrideStatusOf(status: string): ShiftOverrideApprovalStatus | null {
  return LIVE_SHIFT_OVERRIDE_STATUSES.find(candidate => candidate === status) ?? null;
}

export function payloadStringOf(payload: Record<string, unknown>, key: string): string | null {
  const value = payload[key];
  return typeof value === 'string' ? value : null;
}

export function shiftOverrideApprovalInfoOf(row: ShiftOverrideApprovalRow, status: ShiftOverrideApprovalStatus): ShiftOverrideApprovalInfo {
  const breakMinutes = row.payload['breakMinutes'];
  const requestedByDisplayName = [row.firstName, row.lastName].filter(Boolean).join(' ');
  return {
    status,
    requestId: row.id,
    startTime: payloadStringOf(row.payload, 'startTime'),
    endTime: payloadStringOf(row.payload, 'endTime'),
    ...(typeof breakMinutes === 'number' ? { breakMinutes } : {}),
    requestedByDisplayName: requestedByDisplayName.length > 0 ? requestedByDisplayName : null,
    decisionComment: row.decisionComment,
    decidedAt: row.decidedAt?.toISOString() ?? null,
  };
}

export function shiftBreakExceedsSpan(startTime: string, endTime: string, breakMinutes: number): boolean {
  const span = timeRangeDurationMinutes(startTime, endTime);
  return span !== null && breakMinutes > span;
}
